import * as React from 'react'
import { useTranslation } from '@disco/i18n/use-translation'

/**
 * Error shown when the entered password was found in a known breach corpus.
 */
// TODO: duplicates sign-up-form/explain-error - extract into a shared component
export const BreachError = (): React.ReactElement<'span'> => {
  const { t } = useTranslation('accounts')
  return (
    <span>
      {t(
        'accounts:sorryThatPasswordIsNotStrongEnoughAndMayHaveBeenUsedOnOtherSystemsPleaseCreateANewMoreSecurePassword',
        'Sorry, that password is not strong enough, and may have been used on other systems. Please create a new, more secure password.',
      )}{' '}
      <a
        rel="noopener noreferrer"
        target="_blank"
        href="https://support.disco.ac/home/q-how-do-i-choose-a-secure-password"
      >
        {t('accounts:findOutMore', 'Find out more.')}
      </a>
    </span>
  )
}
